import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'

import { intlShape } from '@/checkout-instore-legacy/i18n/intlShape'
import isEmpty from 'lodash/isEmpty'
import some from 'lodash/some'
import head from 'lodash/head'

import {
  getPaymentGroupProperties,
  getAvailablePayments,
} from '@/checkout-instore-legacy/utils/PaymentUtils'

import SummaryCard from './SummaryCard'

const PAYMENT_CARD_NUMBER_DELIVERY = 3
const PAYMENT_CARD_NUMBER_TAKE_AWAY = 2

function ShippingSummaryCard({
  intl,
  active,
  isTakeAwayOnly,
  payments,
  paymentSystems,
  giftCards,
  handleCardClick,
  hover,
  disabled,
}) {
  const title = intl.formatMessage({ id: 'summary.cart.card.payment.title' })

  const filteredPayments = useMemo(
    () => getAvailablePayments(payments, paymentSystems),
    [paymentSystems, payments]
  )

  const hydratedPayments = hydratePayments(filteredPayments, paymentSystems)

  const content = generatePaymentContent(
    hydratedPayments,
    head(giftCards),
    intl
  )
  const paymentNumber = isTakeAwayOnly
    ? PAYMENT_CARD_NUMBER_TAKE_AWAY
    : PAYMENT_CARD_NUMBER_DELIVERY
  return (
    <div id="summary-payment-card">
      <SummaryCard
        title={title}
        number={paymentNumber}
        content={content}
        active={active}
        onClick={handleCardClick}
        hover={hover}
        disabled={disabled}
      />
    </div>
  )
}

const generatePaymentContent = (payments, giftCard, intl) => {
  if (!isEmpty(payments)) {
    if (payments.length === 1) {
      const payment = head(payments)
      const hasInterest = some(
        payment.merchantSellerPayments,
        ({ interestRate }) => interestRate > 0
      )
      if (hasInterest) {
        return (
          <FormattedMessage
            id="summary.cart.card.payment.content.payment.withInterest"
            values={{
              installments: payment.installments || 1,
              paymentSystem: intl.formatMessage({ id: payment.paymentSystem }),
            }}
          />
        )
      }
      return (
        <FormattedMessage
          id="summary.cart.card.payment.content.payment.noInterest"
          values={{
            installments: payment.installments || 1,
            paymentSystem: intl.formatMessage({ id: payment.paymentSystem }),
          }}
        />
      )
    }
    return <FormattedMessage id="summary.cart.card.payment.content.multiple" />
  }
  if (giftCard) {
    return <FormattedMessage id="summary.cart.card.payment.content.giftCard" />
  }
  return <FormattedMessage id="summary.cart.card.payment.empty" />
}

const hydratePayments = (payments, paymentSystems) =>
  payments.map((payment) => {
    const paymentSystem = paymentSystems.find(
      (paymentSystem) => `${paymentSystem.id}` === payment.paymentSystem
    )
    const paymentSystemName = getPaymentGroupProperties(
      paymentSystem.groupName,
      paymentSystem.name
    ).label
    return { ...payment, paymentSystem: paymentSystemName }
  })

ShippingSummaryCard.propTypes = {
  intl: intlShape,
  active: PropTypes.bool,
  payments: PropTypes.array,
  paymentSystems: PropTypes.array,
  isTakeAwayOnly: PropTypes.bool,
  giftCards: PropTypes.array,
  handleCardClick: PropTypes.func.isRequired,
  hover: PropTypes.bool,
  disabled: PropTypes.bool,
}

export default injectIntl(ShippingSummaryCard)
